export const DEFAULT_SORT = "position";
export const LOADER_WIDTH = 200;
export const LOADER_HEIGHT = 56;
export const ITEMS_PER_PAGE = 5;

export const SERPWithoutWebsites = ["popular_products"];
